import countries from "i18n-iso-countries";
// Import English locale
import enLocale from "i18n-iso-countries/langs/en.json";

// Register the locale
countries.registerLocale(enLocale);

export interface CountryOption {
  value: string;
  label: string;
}

// Get all countries in English
// getNames return object { "AF": "Afghanistan", ... } where keys are Alpha-2
// We want Alpha-3 as values.
const names = countries.getNames("en", { select: "official" });

// Map to options with Alpha-3 codes
export const COUNTRY_OPTIONS: CountryOption[] = Object.keys(names)
  .map((alpha2) => {
    const alpha3 = countries.alpha2ToAlpha3(alpha2);
    // Some alpha2 might not have alpha3 or be valid, filter those out if necessary
    // But usually standard list is fine.
    if (!alpha3) return null;
    return {
      value: alpha3,
      label: names[alpha2],
    };
  })
  .filter((opt): opt is CountryOption => opt !== null)
  .sort((a, b) => a.label.localeCompare(b.label));

export const getCountryLabel = (code?: string | null): string => {
  if (!code) return "-";
  // Code refers to Alpha-3
  // getName(code, lang) supports alpha-2 or alpha-3
  const name = countries.getName(code, "en", { select: "official" });
  return name || code;
};
